import { Provider } from '@angular/core';

import { StaticTextUseCasesImpl } from '@app/domain/use-cases/static-text/static-text.use-cases';
import { STATIC_TEXT_USE_CASES } from '@app/domain/use-cases/static-text/static-text.use-cases.contract';

export const staticTextUseCasesProvider: Provider = {
  provide: STATIC_TEXT_USE_CASES,
  useClass: StaticTextUseCasesImpl
};
